import types from 'actions/types'
import {combineReducers} from 'redux'
import {get} from 'lodash'

export const isVisible = (state = false, action) => {
  switch (action.type) {
    case types.PRODUCTION_SHOW_BULK_REMOVE_FROM_JOB_BOARD_DIALOG:
      return true
    case types.PRODUCTION_HIDE_BULK_REMOVE_FROM_JOB_BOARD_DIALOG:
      return false
    default:
      return state
  }
}

export const isBusy = (state = false, action) => {
  switch (action.type) {
    case types.PRODUCTION_REMOVE_ORDERS_FROM_JOB_BOARD_ATTEMPT:
      return true
    case types.PRODUCTION_REMOVE_ORDERS_FROM_JOB_BOARD_SUCCESS:
      return false
    case types.PRODUCTION_REMOVE_ORDERS_FROM_JOB_BOARD_FAILURE:
      return false
    case types.PRODUCTION_GET_ORDER_COUNT_FOR_BULK_REMOVE_ATTEMPT:
      return true
    case types.PRODUCTION_GET_ORDER_COUNT_FOR_BULK_REMOVE_SUCCESS:
      return false
    case types.PRODUCTION_GET_ORDER_COUNT_FOR_BULK_REMOVE_FAILURE:
      return false
    default:
      return state
  }
}

export const affectedOrders = (state = null, action) => {
  switch (action.type) {
    case types.PRODUCTION_SHOW_BULK_REMOVE_FROM_JOB_BOARD_DIALOG:
      return null
    case types.PRODUCTION_GET_ORDER_COUNT_FOR_BULK_REMOVE_SUCCESS:
      return get(action, 'data.count', null)
    default:
      return state
  }
}

export default combineReducers({
  isVisible,
  isBusy,
  affectedOrders,
})
